import React from 'react';
import { TimeLineItem } from './TimeLineItem';
import { TimeBufferItem } from './TimeBufferItem';
import { format, isValid } from 'date-fns';
import { RouteElementType } from '../../utils/utils';

import { safeFormat } from '../../utils/dateUtils';
import { DriverBreakStopItem } from '../Route/DriverBreakStopItem';

export const TimeLine = ({
  onProductChange,
  onAddProducts,
  routeOrders,
  startTime,
  editable = false,
  onUnloadingTimeChange,
  onDailyBreakMinutesChange,
  endPoint,
  distanceSum,
  statuses,
  isAdmin,
  validatedRouteOrders,
  orderMissingServicesPrices,
  setRouteOrders,
  routeId,
  hasReturnPicking = false,
  onRemoveOrder,
}) => {
  const handleStatusChange = (newOrder) => {
    setRouteOrders(prev =>
      prev.map(routeOrder => {
        if (routeOrder.orderId === newOrder.id) {
          return {
            ...routeOrder,
            order: {
              ...routeOrder.order,
              ...newOrder,
            },
          };
        }

        return routeOrder;
      })
    );
  };

  let orderMarkerNumber = 0;

  return (
    <div className="card">
      <div className="card-body pt-0">
        <ul className="timeline ps ps--active-y">
          <li className="timeline-item timeline-icon-success active">
            <div className="timeline-info timeline-info--no-border">
              <p className="font-weight-bold">{startTime.slice(0, 5)} – Wyjazd</p>
            </div>
          </li>

          {routeOrders.map((routeOrder, index) => {
            if (routeOrder.type === RouteElementType.ROUTE_ORDER) {
              orderMarkerNumber += 1
            }
            const validatedRouteOrder = validatedRouteOrders?.find(item => item.routeOrderId === routeOrder.id) ?? null;

            return (
              <React.Fragment key={routeOrder.id}>
                {routeOrder.type === RouteElementType.ROUTE_ORDER && routeOrder.routeBufferStop?.humanFormat && (
                  <TimeBufferItem
                    buffer={routeOrder.routeBufferStop?.humanFormat}
                  />
                )}

                {routeOrder.type === RouteElementType.ROUTE_ORDER && (
                  <TimeLineItem
                    {...routeOrder}
                    index={index}
                    orderNumber={orderMarkerNumber}
                    onAddProducts={onAddProducts}
                    onProductChange={onProductChange}
                    editable={editable}
                    onUnloadingTimeChange={onUnloadingTimeChange}
                    dailyBreakMinutes={routeOrder.routeDriverBreak?.durationInMin}
                    onDailyBreakMinutesChange={onDailyBreakMinutesChange}
                    statuses={statuses}
                    isAdmin={isAdmin}
                    validatedRouteOrder={validatedRouteOrder}
                    orderMissingServicesPrices={orderMissingServicesPrices}
                    onStatusChange={handleStatusChange}
                    routeId={routeId}
                    hasReturnPicking={hasReturnPicking}
                    onRemoveOrder={onRemoveOrder}
                  />
                )}

                {routeOrder.type === RouteElementType.DRIVER_BREAK_TIME && (
                  <DriverBreakStopItem driverStopInMin={routeOrder.durationInMin} />
                )}
              </React.Fragment>
            )
          })}
          <li className="timeline-item timeline-icon-success active">
            <div className="timeline-info timeline-info--no-border">
              <p className="font-weight-bold">{safeFormat(endPoint.arrivalDatetime, 'HH:mm')} – Powrót</p>
              {endPoint && <span>
                Do bazy: {endPoint.distance} km
              </span> }
              <p className="mt-1 tx-15 text-bold-700">Łącznie: {distanceSum} km</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
